import { createContext, useContext } from "react";
import type { SettingsNavGroup } from "@/components/templates";

export interface SettingsNavHostValue {
  nav: SettingsNavGroup[];
  /** The current page's item, when the viewer has it. */
  activeId?: string;
}

/**
 * Set by a settings host (`FinanceSettingsLayout`) for a page that draws the T5 nav itself
 * through `SettingsPageTemplate`. The host then draws no nav of its own for it.
 */
export const SettingsNavHostContext = createContext<SettingsNavHostValue | null>(null);

/**
 * The nav and active item a settings host hands the page, to pass straight to
 * `SettingsPageTemplate`'s `nav` and `activeId`; `null` outside such a host.
 */
export function useSettingsNavHost(): SettingsNavHostValue | null {
  return useContext(SettingsNavHostContext);
}
